export const SummerCampaign2026 = {
  id: "summer-campaign-2026",
  startDate: new Date(2026, 6, 1, 0, 0, 0),
  endDate: new Date(2026, 7, 15, 23, 59, 59),
};

export const isSummerCampaign2026Active = (date: Date): boolean =>
  date >= SummerCampaign2026.startDate && date <= SummerCampaign2026.endDate;